/**
 * Evento que el temporizador de inactividad de `AuthProvider` trata como
 * actividad del usuario, igual que un clic o una tecla.
 */
export const USER_ACTIVITY_EVENT = "sdt:user-activity";

/**
 * Reinicia el temporizador de inactividad sin interacción del usuario. Lo usa,
 * por ejemplo, una subida larga directa a GCS: no toca la API ni la página, y
 * sin esto la sesión se cerraría a mitad de la subida.
 */
export const markUserActivity = () => {
  globalThis.window?.dispatchEvent(new Event(USER_ACTIVITY_EVENT));
};
